import React from "react";
import {
  DragDropContext,
  DropTarget,
  DragDropContextProvider
} from "react-dnd";
import HTML5Backend, { NativeTypes } from "react-dnd-html5-backend";
import { compose } from "recompose";

const Component = compose(
  DragDropContext(HTML5Backend),
  DropTarget(
    props => [NativeTypes.FILE],
    {
      drop(props, monitor) {
        if (monitor) {
          props.onDrop(monitor.getItem().files);
        }
      }
    },
    (connect, monitor) => ({
      connectDropTarget: connect.dropTarget(),
      isOver: monitor.isOver()
    })
  )
)(({ connectDropTarget, children, isOver }) =>
  connectDropTarget(<span>{children({ isOver })}</span>)
);

export default props => (
  <DragDropContextProvider backend={HTML5Backend}>
    <Component {...props} />
  </DragDropContextProvider>
);



// WEBPACK FOOTER //
// ./src/components/generic/kit/DragNDrop/index.js